<template lang="pug">
  form(action="" v-on:submit.prevent="onSearch()")
    div(class="modal-card" style="width: 400px")
      header(class="modal-card-head")
        p(class="modal-card-title")
          | 絞り込み条件

      section(class="modal-card-body")
        b-field(label="書籍名/ISBN")
          b-input(
            type="text"
            v-model="formProps.accepting_order_item_book_name_or_accepting_order_item_isbn_cont"
            id="book-isbn-name"
          )

        b-field(label="帳合")
          b-input(
            type="text"
            v-model="formProps.accepting_order_item_agency_code_or_accepting_order_item_agency_name_cont"
            id="agency-code"
          )

        b-field(label="取次書店コード")
          b-input(
            type="text"
            v-model="formProps.accepting_order_item_agency_shop_code_cont"
            id="agency-shop-code"
          )

        b-field(label="書店名")
          b-input(
            type="text"
            v-model="formProps.accepting_order_item_book_shop_name_cont"
            id="final-book-shop-name"
          )

        b-field(label="受注経路")
          b-select(v-model="formProps.accepting_order_item_order_route_id_eq" id="order-route-id")
            option(value="")
            option(
                v-for="option in order_routes"
                :value="option.id"
                :key="option.id")
              | {{ option.name }}

        b-field(label="受注管理ID")
          b-input(
            type="text"
            v-model="formProps.accepting_order_item_accepting_order_sid_cont"
            id="accepting-order-sid"
          )

        b-field(label="配本管理ID")
          b-input(
            type="text"
            v-model="formProps.manipulated_order_sid_cont"
            id="manipulated-order-sid"
          )

        b-field(label="備忘")
          b-input(
            type="text"
            v-model="formProps.accepting_order_item_bibo_cont"
            id="accepting-order-item-bibo"
          )

        b-field(label="客注")
          b-input(
            type="text"
            v-model="formProps.accepting_order_item_kyakutyu_memo_cont"
            id="accepting-order-item-kyakutyu-memo"
          )

        b-field(label="グループ名")
          b-input(
            type="text"
            v-model="formProps.accepting_order_item_final_book_shop_final_book_shop_group_shop_name_cont"
            id="final-book-shop-group-shop-name"
          )

        b-field(label="登録者")
          b-input(
            type="text"
            v-model="formProps.accepting_order_item_accepting_order_user_name_cont"
            id="manipulated-order-user-name"
          )

      footer(class="modal-card-foot")
        button(class="button is-info is-fullwidth")
          i.fas.fa-undefine.fa-search.icon-left
          | この条件で探す
        button(class="button" type="button" @click="$parent.close()")
          i.fas.fa-times
</template>


<script>
  import CacheDispatcher from 'mixins/cache_dispatcher'

  export default {
    props: [ 'formProps' ],
    mixins: [CacheDispatcher],
    computed: {
      order_routes() { return this.$store.getters['AcceptingOrderRoutes/records'] },
    },
    methods: {
      onSearch(){
        this.$emit('update:formProps', this.formProps)
        this.$emit('on-search')
        this.$parent.close()
      }
    },
    created() {
      this.dispatch_with_cache('AcceptingOrderRoutes/fetch', 'accepting_order_routes', this.order_routes)
    }
  }

</script>